export const PIDAlertsMock = [
  {
    id: 'cac7ae5a-6a95-49e0-8760-15862bd9072c',
    alertRuleId: '9061c894-0637-4198-9c43-c6ffe53c3ad1',
    alertType: 'manufacturer',
    severity: 'shutdown',
    title: 'dp1 separator high',
    openingTime: '2024-06-24T01:19:28.429Z',
    lastUpdated: '2024-06-24T01:19:28.429Z',
    status: 'open',
    acknowledged: false,
    inMaintenance: false,
    manufacturerCode: null,
    detailedDescription: 'dP1 Separator high',
    recommendation: null,
    affectedDevices: ['527'],
    affectedDevicesWithAttributes: [
      {
        id: '527',
        name: '#1 - ZT45',
      },
    ],
    affectedDevicesNames: ['#1 - ZT45'],
  },

  {
    id: '704a3852-268a-4707-b428-4036101ee7ed',
    alertRuleId: 'c13ccdb8-00d4-4b80-a788-f2f05e9c6585',
    alertType: 'manufacturer',
    severity: 'shutdown',
    title: 'power interruption',
    openingTime: '2024-06-22T14:10:51.743Z',
    lastUpdated: '2024-06-24T01:17:48.713Z',
    status: 'close',
    acknowledged: false,
    inMaintenance: false,
    manufacturerCode: null,
    detailedDescription:
      'Power interruption: Motor starter(s) not working / No contact to input D8 / Intermittent control power',
    recommendation: null,
    affectedDevices: ['527'],
    affectedDevicesWithAttributes: [
      {
        id: '527',
        name: '#1 - V200TS',
      },
    ],
    affectedDevicesNames: ['#1 - V200TS'],
  },
  {
    id: '296fdfdd-8256-4265-b968-ffdb2490b5a2',
    alertRuleId: 'de821d91-3d78-46b1-b052-8d59c2dc37f7',
    alertType: 'custom',
    severity: 'warning',
    title: 'Low Pressure',
    openingTime: '2024-06-24T19:45:00.000Z',
    lastUpdated: '2024-06-24T19:49:00.000Z',
    status: 'close',
    acknowledged: false,
    inMaintenance: false,
    detailedDescription: 'Low Pressure',
    recommendation: null,
    affectedDevices: ['8dc593e4-a6c3-49f5-a042-905c7fdd8421'],
    affectedDevicesWithAttributes: [
      {
        id: '8dc593e4-a6c3-49f5-a042-905c7fdd8421',
        name: 'Pressure 2',
      },
    ],
    metricNames: ['pressureBar'],
    affectedDevicesNames: ['Pressure 2'],
  },
  {
    id: '37d83141-aaa3-4962-b252-70f661cb6a4e',
    alertRuleId: 'cf8ac47c-f57a-4bbc-838b-a807d5781d7b',
    alertType: 'manufacturer',
    severity: 'shutdown',
    title: 'General Shutdown',
    openingTime: '2024-06-13T12:38:38.296Z',
    lastUpdated: '2024-06-13T13:33:50.999Z',
    status: 'close',
    acknowledged: true,
    inMaintenance: false,
    manufacturerCode: null,
    detailedDescription:
      'General Shutdown: One or more operating parameters have exceeded the trip limit causing the compressor to shutdown.  Inspect the compressor for the root cause of the shutdown the allow the compressor to return to normal operating parametersbefore resetting the controller and attempting a restart.\n',
    recommendation: null,
    affectedDevices: ['1f0293d0-11b8-4722-a377-179ce354d1a1'],
    affectedDevicesWithAttributes: [
      {
        id: '1f0293d0-11b8-4722-a377-179ce354d1a1',
        name: '#2 - V200TS',
      },
    ],
    affectedDevicesNames: ['#2 - V200TS'],
  },
  {
    id: 'a636012a-870e-42d0-ae8b-ebfa7f7722c3',
    alertRuleId: '79680513-5a1c-40a2-b967-b8d6746e5152',
    alertType: 'custom',
    severity: 'warning',
    title: 'High Dewpoint',
    openingTime: '2024-06-06T19:48:00.000Z',
    lastUpdated: '2024-06-19T06:21:00.000Z',
    status: 'open',
    acknowledged: false,
    inMaintenance: false,
    detailedDescription: 'Dewpoint is higher than expected\n\nPlease check dryer operating condition',
    recommendation: null,
    affectedDevices: ['3b646363-1af7-40db-a049-0f9b9b0eee2e'],
    affectedDevicesWithAttributes: [
      {
        id: '3b646363-1af7-40db-a049-0f9b9b0eee2e',
        name: 'Dew Point',
      },
    ],
    metricNames: ['dewpointTemperatureCelsius'],
    affectedDevicesNames: ['Dew Point'],
  },
  {
    id: 'b82d5a69-7b24-4013-b022-35796c4c09e1',
    alertRuleId: 'a9bcb1ea-8740-41f6-bd5e-a87a586b5279',
    alertType: 'custom',
    severity: 'warning',
    title: 'Critical Pressure Drop',
    openingTime: '2024-06-22T16:03:00.000Z',
    lastUpdated: '2024-06-24T01:21:00.000Z',
    status: 'close',
    acknowledged: false,
    inMaintenance: false,
    detailedDescription: 'Alerts when the pressure drops below 87 psi for more than 10 min',
    recommendation: null,
    affectedDevices: ['533'],
    affectedDevicesWithAttributes: [
      {
        id: '533',
        name: 'Flow and Pressure Sensor',
      },
    ],
    metricNames: ['pressureBar'],
    affectedDevicesNames: ['Flow and Pressure Sensor'],
  },
];
